const ProjectsList = () =>
  import(/* webpackChunkName: "ProjectsList" */ "@/components/rapsotec/projects/List.vue");
const Project = () =>
  import(/* webpackChunkName: "Project" */ "@/components/rapsotec/projects/Project.vue");
import ProjectChildrens from "./projects/ProjectChildrens";

import { projectUserPermission } from "@/utils/middlewarePermissions";

export default [
  {
    path: "",
    name: "projectsList",
    component: ProjectsList,
  },
  {
    path: ":projectId(\\d+)",
    component: Project,
    beforeEnter: projectUserPermission,
    children: ProjectChildrens,
  },
];
